import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import OnCallTeamData from "./on-call-team-data";
import OnCallTeamForm from "./on-call-team-form";

const OnCallTeam = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_ON_CALL_TEAM",
      "DEVELOPER_ON_CALL_TEAM"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ON_CALL_TEAM")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <OnCallTeamData />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <OnCallTeamForm />
    </ET3PageDiv>
  );
});

export default OnCallTeam;
